"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");
/**
 * Procedure that enables Permissions on a Security Token
 */


var EnableGeneralPermissionManager =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(EnableGeneralPermissionManager, _Procedure_1$Procedur);

  function EnableGeneralPermissionManager() {
    var _this;

    _classCallCheck(this, EnableGeneralPermissionManager);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EnableGeneralPermissionManager).apply(this, arguments));
    _this.type = types_1.ProcedureType.EnableGeneralPermissionManager;
    return _this;
  }
  /**
   * Enable Permissions on the Security Token
   */


  _createClass(EnableGeneralPermissionManager, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var symbol, contractWrappers, securityToken, tokenAddress, moduleName, moduleAddress;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                symbol = this.args.symbol;
                contractWrappers = this.context.contractWrappers;
                _context.prev = 2;
                _context.next = 5;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 5:
                securityToken = _context.sent;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](2);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 11:
                _context.next = 13;
                return securityToken.address();

              case 13:
                tokenAddress = _context.sent;
                moduleName = contract_wrappers_1.ModuleName.GeneralPermissionManager;
                _context.next = 17;
                return contractWrappers.getModuleFactoryAddress({
                  tokenAddress: tokenAddress,
                  moduleName: moduleName
                });

              case 17:
                moduleAddress = _context.sent;
                _context.next = 20;
                return this.addTransaction(securityToken.addModuleWithLabel, {
                  tag: types_1.PolyTransactionTag.EnableGeneralPermissionManager
                })({
                  moduleName: moduleName,
                  address: moduleAddress,
                  archived: false
                });

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));
    }
  }]);

  return EnableGeneralPermissionManager;
}(Procedure_1.Procedure);

exports.EnableGeneralPermissionManager = EnableGeneralPermissionManager;